// Lesson 3 — Triplets & the pair. The learner holds two 5-Bamboo and two
// 3-Circle (pairs that can grow into triplets or serve as the hand's one pair),
// plus a lone West wind floater. The taught move is discarding that floater.

import { createDealBuilder, fillerBot } from './deckBuilder.js';
import type { LessonScript } from '../types.js';

const b = createDealBuilder();

const souFiveA = b.suit('sou', 5);
const souFiveB = b.suit('sou', 5);
const pinThreeA = b.suit('pin', 3);
const pinThreeB = b.suit('pin', 3);
const west = b.honor('west');

const human = [
  souFiveA,
  souFiveB,
  pinThreeA,
  pinThreeB,
  b.suit('man', 4),
  b.suit('man', 5),
  b.suit('man', 6),
  b.suit('pin', 6),
  b.suit('pin', 7),
  b.suit('pin', 8),
  b.suit('sou', 8),
  b.suit('sou', 2),
  west,
];

const seat1 = fillerBot(b, 'east', [['man', 1], ['man', 7], ['pin', 4], ['sou', 3]]);
const seat2 = fillerBot(b, 'south', [['pin', 1], ['sou', 6], ['man', 3], ['pin', 7]]);
const seat3 = fillerBot(b, 'north', [['sou', 1], ['man', 5], ['pin', 5], ['sou', 7]]);

const wall = [
  b.suit('man', 1),
  b.suit('pin', 2),
  b.suit('sou', 4),
  b.suit('man', 8),
  b.suit('pin', 5),
  b.suit('sou', 6),
];

export const lesson3TripletsPair: LessonScript = {
  id: 'lesson-3-triplets-pair',
  titleKey: 'lesson.script.triplets.title',
  deal: { hands: [human, seat1, seat2, seat3], wall },
  steps: [
    {
      instructionKey: 'lesson.script.triplets.intro',
      expectedAction: { kind: 'info' },
      highlightTileIds: [souFiveA.id, souFiveB.id, pinThreeA.id, pinThreeB.id],
      autoAdvance: false,
    },
    {
      instructionKey: 'lesson.script.triplets.discard',
      expectedAction: { kind: 'discard', tileId: west.id },
      highlightTileIds: [west.id],
      autoAdvance: true,
    },
    { instructionKey: 'lesson.script.triplets.done', expectedAction: { kind: 'info' }, autoAdvance: false },
  ],
};
